<template>
  <k-menu
    lazy
    :close-on-content-click="false"
    transition="false"
    offset-y
    full-width
    :nudge-left="40"
    max-width="320"
    v-model="active"
    ref="datepicker">
    <k-text-field
      slot="activator"
      :label="label"
      v-model="formattedDate"
      hide-details
      readonly></k-text-field>
    <k-date-picker :first-day-of-week="firstDayOfWeek" no-title v-model="date" type="month" :allowed-dates="allowedDates"></k-date-picker>
  </k-menu>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    value: Date,
    'date-format': {type: String, default: "DD.MM.YYYY"},
    'first-day-of-week': {type: String, default: "0"},
    label: String,
    'disabled-before': Date,
    'disabled-after': Date
  },
  components: {
  },
  data() {
    return {
      active: false,
      lastPicker: "MONTH",
      watcher: undefined,
      formattedDate: moment(this.value).format("MM.YYYY")
    }
  },
  watch: {
    active (val) {
      if(val) {
        this.$nextTick(() => {
          this.watcher = this.$watch(() => {
            return this.$refs.datepicker.$children[1].activePicker // TODO: KORJAA PURKKA
          },
          (val) => {
            this.lastPicker = val;
          })
        })
      } else if (typeof(this.watcher) == "function") {
        this.watcher();
      }
    },
/*    value (newVal, oldVal) {
      console.log(this.lastPicker);
      if(this.lastPicker == "MONTH") {
        this.active = false;
      }
    }*/
  },
  methods: {
    allowedDates (date) {
      if(typeof(this.disabledBefore) != "undefined" || typeof(this.disabledAfter) != "undefined") {
        return (typeof(this.disabledBefore) != "undefined" && moment(date).isSameOrAfter(this.disabledBefore,"day")) || (typeof(this.disabledAfter) != "undefined" && moment(date).isSameOrBefore(this.disabledAfter,"day"));
      }
      return true;
    },
    month_to_timestamp(date) {
        // YYYY-MM
        let split_date = date.split("-");

        let start_date = moment([split_date[0], split_date[1] - 1]).startOf('month').unix();
        let end_date = moment([split_date[0], split_date[1] - 1]).endOf('month').unix();

        return [start_date, end_date];
    }
  },
  computed: {
    date: {
      get () {
        return moment(this.value).format();
      },
      set (val) {
        this.formattedDate = moment(val).format("MM.YYYY");
        this.$emit('input', this.month_to_timestamp(moment(val).format("YYYY-MM")));
        this.$emit('change', this.month_to_timestamp(moment(val).format("YYYY-MM")));
        this.active = false;
      }
    },
/*    formattedDate () {
      console.log("FORMAT DATE", this.date);
      return moment(this.date).format("MM.YYYY");
    }*/
  }
}
</script>
